import { Permission, Resource } from '@seccl/client';

export const FIRM_NODES_UI_FEATURE_FLAG = 'seccl-34453-firm-nodes-ui';

export const hasFirmNodesViewAccess = (hasScope: (resource: Resource, permission: Permission) => boolean): boolean =>
  hasScope(Resource.FirmManagement, Permission.Read) || hasScope(Resource.FirmManagement, Permission.ReadWrite);

// NOTE: To be used by the edit pages; SECCL-34498
export const hasFirmNodesEditAccess = (hasScope: (resource: Resource, permission: Permission) => boolean): boolean =>
  hasScope(Resource.FirmManagement, Permission.ReadWrite);
